var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBusiness = function SvgBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.835 4.167v-2.5a.833.833 0 0 1 .833-.834h6.667a.833.833 0 0 1 .833.834v2.5h3.333a.833.833 0 0 1 .834.833v11.667a.833.833 0 0 1-.834.833h-15a.833.833 0 0 1-.833-.833V5a.833.833 0 0 1 .833-.833h3.334Zm-2.5 9.166v2.5h13.333v-2.5H2.335Zm0-1.666h13.333V5.833H2.335v5.834ZM6.5 2.5v1.667h5V2.5h-5Zm1.667 6.667h1.667v1.666H8.168V9.167Z",
    fill: "#000"
  })));
};
export default SvgBusiness;